import { createAction } from '@reduxjs/toolkit'

import { RemoveBrandFanMemberActionType } from '../types'

export const removeBrandFanMember = createAction(
  RemoveBrandFanMemberActionType.REMOVE_BRAND_FAN_MEMBER,
  (groupId: number, memberId: number) => ({ payload: { groupId, memberId } }),
)
